module.exports = __webpack_public_path__ + "img/rs.68a94875.svg";